import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  orPromise1iucc2to2udt2 as orPromise,
  $3l5vvh8yg0ier as $,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  jsonReader2agwreccj3lmk as jsonReader,
  jsonReaderkr2c3w0efm9b as jsonReader_0,
} from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/json/JsonReaders.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toApolloResponse9u5mcqg84l2p as toApolloResponse,
  parseResponse2l74cu4whks78 as parseResponse,
} from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Operations.mjs';
import { Token_NULL_getInstance2d65is50ce53 as Token_NULL_getInstance } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/json/JsonReader.mjs';
import { readErrors1y0wtxnlur21l as readErrors } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/internal/ResponseParser.mjs';
import {
  RouterError3i6hxcnqsy5l3 as RouterError,
  ApolloNetworkException3denf70pfh242 as ApolloNetworkException,
  ApolloException16lek20l78zc3 as ApolloException,
  ApolloHttpException3o30u8ntkffuh as ApolloHttpException,
} from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { Subscription2xxf73xmsvgi0 as Subscription } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Subscription.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { uuid4al7pp0fcb8o5 as uuid4 } from '../../../../../../uuid/com/benasher44/uuid/uuid.mjs';
import { Builder16nv925388a0q as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ApolloResponse.mjs';
import {
  flowOf16f7h10nre075 as flowOf,
  flow3tazazxj2t7g4 as flow,
} from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Builders.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  multipartBodyFlow272n2l39kgnug as multipartBodyFlow,
  get_isGraphQLResponse3ogjhw8yzfes1 as get_isGraphQLResponse,
  get_isMultipart1je26zsopcnca as get_isMultipart,
} from '../../internal/multipart.mjs';
import { catchrcnx5mlu3pkp as catch_0 } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Errors.mjs';
import { currentTimeMillis8vwamy6polhm as currentTimeMillis } from '../../../../../../apollo-kotlin-apollo-mpp-utils/com/apollographql/apollo/mpp/utils.mjs';
import { HttpInfo25xgxbxy3emkc as HttpInfo } from './HttpExecutionContext.mjs';
import {
  dispose2t7a37uqicel0 as dispose,
  HttpInterceptor2khzkwmar9lg6 as HttpInterceptor,
  DefaultHttpInterceptorChain22k3s5gesb9pu as DefaultHttpInterceptorChain,
} from './HttpInterceptor.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { IncrementalDeliveryProtocol_V0_1_getInstancefhanbu89c1sm as IncrementalDeliveryProtocol_V0_1_getInstance } from '../IncrementalDeliveryProtocol.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { DefaultHttpRequestComposer3cbqxfvy17yg2 as DefaultHttpRequestComposer } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/http/DefaultHttpRequestComposer.mjs';
import { DefaultHttpEngine26xguluicr03l as DefaultHttpEngine } from './DefaultHttpEngine.js.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/FlowCollector.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { emitAll157ci673e68ia as emitAll } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Collect.mjs';
import { get_impl1focltg7f8wvg as get_impl } from '../../internal/incremental/IncrementalDeliveryProtocolImpl.mjs';
import { plus20p0vtfmu0596 as plus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { Key_getInstance3kkpczi3zr320 as Key_getInstance } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CustomScalarAdapters.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { equals2v6cggk171b6e as equals_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function HttpNetworkTransport$execute$slambda$o$collect$slambda($$this$unsafeFlow, this$0, $request, $httpResponse, $millisStart) {
  return constructCallableReference((value, $completion) => orPromise($completion, function *($completion) {
    var tmp0 = $$this$unsafeFlow;
    var it = value;
    var tmp$ret$1 = withHttpInfo(this$0, it, $request.requestUuid_1, $httpResponse, $millisStart);
    yield* tmp0.emit_t92u1f_k$(tmp$ret$1, $completion);
    return Unit_instance;
  }), 1);
}
function HttpNetworkTransport$multipleResponses$o$collect$slambda($$this$unsafeFlow, $operation, $request, $customScalarAdapters, this$0, $incrementalResultsMerger) {
  return constructCallableReference((value, $completion) => orPromise($completion, function *($completion) {
    var tmp0 = $$this$unsafeFlow;
    var tmp2 = value;
    $l$block: {
      var tmp;
      if (isInterface($operation, Subscription())) {
        // Inline function 'kotlin.apply' call
        var this_0 = jsonReader_0(tmp2);
        var tmp0_elvis_lhs = $request.ignoreUnknownKeys_1;
        this_0.ignoreUnknownKeys_132xpl_k$(tmp0_elvis_lhs == null ? true : tmp0_elvis_lhs);
        var reader = this_0;
        var payloadResponse = null;
        var errors = null;
        reader.beginObject_5wddq0_k$();
        while (reader.hasNext_bitz1p_k$()) {
          switch (reader.nextName_njxula_k$()) {
            case 'payload':
              if (reader.peek_21nx7_k$().equals(Token_NULL_getInstance())) {
                reader.skipValue_18u2ci_k$();
              } else {
                payloadResponse = parseResponse(reader, $operation, VOID, $customScalarAdapters, null);
              }

              break;
            case 'errors':
              if (reader.peek_21nx7_k$().equals(Token_NULL_getInstance())) {
                reader.skipValue_18u2ci_k$();
              } else {
                errors = readErrors(reader);
              }

              break;
            default:
              reader.skipValue_18u2ci_k$();
              break;
          }
        }
        reader.endObject_ofuv3u_k$();
        var tmp_0;
        if (!(errors == null)) {
          tmp_0 = errorResponse(this$0, $operation, RouterError().new_com_apollographql_apollo_exception_RouterError_4vl01r_k$(errors));
        } else if (!(payloadResponse == null)) {
          tmp_0 = payloadResponse;
        } else {
          tmp_0 = null;
        }
        tmp = tmp_0;
      } else {
        if ($incrementalResultsMerger._v == null) {
          $incrementalResultsMerger._v = this$0.incrementalDeliveryProtocolImpl_1.newIncrementalResultsMerger_frcl62_k$();
        }
        var merged = $incrementalResultsMerger._v.merge_wv0l0k_k$(tmp2);
        var deferredFragmentIdentifiers = $incrementalResultsMerger._v.get_deferredFragmentIdentifiers_ylh6by_k$();
        var isLast = !$incrementalResultsMerger._v.get_hasNext_csdx38_k$();
        var tmp_1;
        if ($incrementalResultsMerger._v.get_isEmptyResponse_kjiv23_k$()) {
          tmp_1 = null;
        } else {
          tmp_1 = toApolloResponse(jsonReader(merged), $operation, VOID, $customScalarAdapters, deferredFragmentIdentifiers).newBuilder_dnl2aj_k$().isLast_feje11_k$(isLast).build_1k0s4u_k$();
        }
        tmp = tmp_1;
      }
      var tmp0_elvis_lhs_0 = tmp;
      var tmp_2;
      if (tmp0_elvis_lhs_0 == null) {
        break $l$block;
      } else {
        tmp_2 = tmp0_elvis_lhs_0;
      }
      var transformed = tmp_2;
      yield* tmp0.emit_t92u1f_k$(transformed, $completion);
    }
    return Unit_instance;
  }), 1);
}
function errorResponse($this, operation, throwable) {
  var tmp;
  if (throwable instanceof ApolloException()) {
    tmp = throwable;
  } else {
    tmp = ApolloNetworkException().new_com_apollographql_apollo_exception_ApolloNetworkException_7j59h6_k$('Error while reading JSON response', throwable);
  }
  var apolloException = tmp;
  var tmp0_requestUuid = uuid4();
  return Builder().new_com_apollographql_apollo_api_ApolloResponse_Builder_h8chhh_k$(operation, tmp0_requestUuid).exception_5qwc7n_k$(apolloException).isLast_feje11_k$(true).build_1k0s4u_k$();
}
function errorResponse_0($this, operation, httpResponse) {
  var tmp;
  if ($this.exposeErrorBody_1) {
    tmp = httpResponse.get_body_wojkyz_k$();
  } else {
    var tmp0_safe_receiver = httpResponse.get_body_wojkyz_k$();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.close_yn9xrc_k$();
    }
    tmp = null;
  }
  var maybeBody = tmp;
  var apolloException = ApolloHttpException().new_com_apollographql_apollo_exception_ApolloHttpException_vl9kqq_k$(httpResponse.statusCode_1, httpResponse.headers_1, maybeBody, 'Http request failed with status code `' + httpResponse.statusCode_1 + '`');
  return flowOf(errorResponse($this, operation, apolloException));
}
function singleResponse($this, request, customScalarAdapters, httpResponse) {
  var operation = request.operation_1;
  // Inline function 'kotlin.apply' call
  var this_0 = jsonReader_0(ensureNotNull(httpResponse.get_body_wojkyz_k$()));
  var tmp0_elvis_lhs = request.ignoreUnknownKeys_1;
  this_0.ignoreUnknownKeys_132xpl_k$(tmp0_elvis_lhs == null ? true : tmp0_elvis_lhs);
  var response = toApolloResponse(this_0, operation, VOID, customScalarAdapters, null).newBuilder_dnl2aj_k$().addExecutionContext_c49mf3_k$(httpResponse.executionContext_1).isLast_feje11_k$(true).build_1k0s4u_k$();
  return flowOf(response);
}
function multipleResponses($this, request, customScalarAdapters, httpResponse) {
  var incrementalResultsMerger = {_v: null};
  var operation = request.operation_1;
  // Inline function 'kotlinx.coroutines.flow.mapNotNull' call
  // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
  var this_0 = multipartBodyFlow(httpResponse);
  // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
  var tmp = new (HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1())(this_0, operation, request, customScalarAdapters, $this, incrementalResultsMerger);
  return catch_0(tmp, HttpNetworkTransport$multipleResponses$slambda(operation, $this));
}
function wrapIfNeeded($this, $receiver) {
  var tmp;
  if ($receiver instanceof ApolloException()) {
    tmp = $receiver;
  } else {
    tmp = ApolloNetworkException().new_com_apollographql_apollo_exception_ApolloNetworkException_7j59h6_k$('Error while reading response', $receiver);
  }
  return tmp;
}
function withHttpInfo($this, $receiver, requestUuid, httpResponse, millisStart) {
  // Inline function 'kotlin.apply' call
  var this_0 = $receiver.newBuilder_dnl2aj_k$().requestUuid_f5bk3d_k$(requestUuid);
  if (!(httpResponse == null)) {
    this_0.addExecutionContext_c49mf3_k$(new (HttpInfo())(millisStart, currentTimeMillis(), httpResponse.statusCode_1, httpResponse.headers_1));
  }
  return this_0.build_1k0s4u_k$();
}
var EngineInterceptorClass;
function EngineInterceptor() {
  if (EngineInterceptorClass === VOID) {
    class $ {
      constructor($outer) {
        this.$this_1 = $outer;
      }
      *intercept_ut4154_k$(request, chain, $completion) {
        return yield* this.$this_1.engine_1.execute_2fydhe_k$(request, $completion);
      }
    }
    protoOf($).dispose_3nnxhr_k$ = dispose;
    initMetadataForClass($, 'EngineInterceptor', VOID, VOID, [HttpInterceptor()], [2]);
    EngineInterceptorClass = $;
  }
  return EngineInterceptorClass;
}
var BuilderClass;
function Builder_0() {
  if (BuilderClass === VOID) {
    class $ {
      constructor() {
        this.httpRequestComposer_1 = null;
        this.serverUrl_1 = null;
        this.engine_1 = null;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.interceptors_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        this.exposeErrorBody_1 = false;
        this.incrementalDeliveryProtocol_1 = IncrementalDeliveryProtocol_V0_1_getInstance();
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_0.headers_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
      }
      serverUrl_kg2d9h_k$(serverUrl) {
        // Inline function 'kotlin.apply' call
        this.serverUrl_1 = serverUrl;
        return this;
      }
      exposeErrorBody_8ps9a7_k$(exposeErrorBody) {
        // Inline function 'kotlin.apply' call
        this.exposeErrorBody_1 = exposeErrorBody;
        return this;
      }
      httpEngine_5bmjw8_k$(httpEngine) {
        // Inline function 'kotlin.apply' call
        this.engine_1 = httpEngine;
        return this;
      }
      interceptors_a6mi5a_k$(interceptors) {
        // Inline function 'kotlin.apply' call
        this.interceptors_1.clear_j9egeb_k$();
        this.interceptors_1.addAll_h3ej1q_k$(interceptors);
        return this;
      }
      build_1k0s4u_k$() {
        // Inline function 'kotlin.check' call
        if (!(this.httpRequestComposer_1 == null || this.serverUrl_1 == null)) {
          var message = "It is an error to set both 'httpRequestComposer' and 'serverUrl'";
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
        }
        var tmp0_elvis_lhs = this.httpRequestComposer_1;
        var composer = tmp0_elvis_lhs == null ? DefaultHttpRequestComposer().new_com_apollographql_apollo_api_http_DefaultHttpRequestComposer_cukmn7_k$(this.serverUrl_1) : tmp0_elvis_lhs;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.headers_1.isEmpty_y1axqb_k$()) {
          this.interceptors_1.add_utx5q5_k$(new (TransportHeadersInterceptor())(this.headers_1));
        }
        var tmp1_elvis_lhs = this.engine_1;
        return new (HttpNetworkTransport())(composer, tmp1_elvis_lhs == null ? DefaultHttpEngine() : tmp1_elvis_lhs, this.interceptors_1, this.exposeErrorBody_1, this.incrementalDeliveryProtocol_1);
      }
    }
    initMetadataForClass($, 'Builder', Builder_0);
    BuilderClass = $;
  }
  return BuilderClass;
}
var TransportHeadersInterceptorClass;
function TransportHeadersInterceptor() {
  if (TransportHeadersInterceptorClass === VOID) {
    class $ {
      constructor(headers) {
        this.headers_1 = headers;
      }
      *intercept_ut4154_k$(request, chain, $completion) {
        return yield* chain.proceed_voxjs5_k$(request.newBuilder$default_4j1svq_k$().addHeaders_2d4x0x_k$(this.headers_1).build_1k0s4u_k$(), $completion);
      }
    }
    protoOf($).dispose_3nnxhr_k$ = dispose;
    initMetadataForClass($, 'TransportHeadersInterceptor', VOID, VOID, [HttpInterceptor()], [2]);
    TransportHeadersInterceptorClass = $;
  }
  return TransportHeadersInterceptorClass;
}
var sam$kotlinx_coroutines_flow_FlowCollector$0Class;
function sam$kotlinx_coroutines_flow_FlowCollector$0() {
  if (sam$kotlinx_coroutines_flow_FlowCollector$0Class === VOID) {
    class $_0 {
      constructor(function_0) {
        this.function_1 = function_0;
      }
      *emit_t92u1f_k$(value, $completion) {
        return yield* $(this.function_1(value, $completion), $completion);
      }
      getFunctionDelegate_jtodtf_k$() {
        return this.function_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, FlowCollector()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.getFunctionDelegate_jtodtf_k$(), other.getFunctionDelegate_jtodtf_k$());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.getFunctionDelegate_jtodtf_k$());
      }
    }
    initMetadataForClass($_0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector(), FunctionAdapter()], [1]);
    sam$kotlinx_coroutines_flow_FlowCollector$0Class = $_0;
  }
  return sam$kotlinx_coroutines_flow_FlowCollector$0Class;
}
var sam$kotlinx_coroutines_flow_FlowCollector$0Class_0;
function sam$kotlinx_coroutines_flow_FlowCollector$0_0() {
  if (sam$kotlinx_coroutines_flow_FlowCollector$0Class_0 === VOID) {
    class $_0 {
      constructor(function_0) {
        this.function_1 = function_0;
      }
      *emit_t92u1f_k$(value, $completion) {
        return yield* $(this.function_1(value, $completion), $completion);
      }
      getFunctionDelegate_jtodtf_k$() {
        return this.function_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, FlowCollector()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.getFunctionDelegate_jtodtf_k$(), other.getFunctionDelegate_jtodtf_k$());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.getFunctionDelegate_jtodtf_k$());
      }
    }
    initMetadataForClass($_0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector(), FunctionAdapter()], [1]);
    sam$kotlinx_coroutines_flow_FlowCollector$0Class_0 = $_0;
  }
  return sam$kotlinx_coroutines_flow_FlowCollector$0Class_0;
}
var HttpNetworkTransport$execute$1$$inlined$map$1Class;
function HttpNetworkTransport$execute$1$$inlined$map$1() {
  if (HttpNetworkTransport$execute$1$$inlined$map$1Class === VOID) {
    class $ {
      constructor($this, this$0, $request, $httpResponse, $millisStart) {
        this.$this_1 = $this;
        this.this$0__1 = this$0;
        this.$request_1 = $request;
        this.$httpResponse_1 = $httpResponse;
        this.$millisStart_1 = $millisStart;
      }
      *collect_ooju95_k$(collector, $completion) {
        var tmp = HttpNetworkTransport$execute$slambda$o$collect$slambda(collector, this.this$0__1, this.$request_1, this.$httpResponse_1, this.$millisStart_1);
        yield* this.$this_1.collect_aksokr_k$(new (sam$kotlinx_coroutines_flow_FlowCollector$0())(tmp), $completion);
        return Unit_instance;
      }
      collect_aksokr_k$(collector, $completion) {
        return this.collect_ooju95_k$(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    HttpNetworkTransport$execute$1$$inlined$map$1Class = $;
  }
  return HttpNetworkTransport$execute$1$$inlined$map$1Class;
}
function HttpNetworkTransport$execute$slambda(this$0, $httpRequest, $request, $customScalarAdapters) {
  return constructCallableReference(($this$flow, $completion) => orPromise($completion, function *($completion) {
    var millisStart = currentTimeMillis();
    var throwable = null;
    var tmp;
    try {
      tmp = yield* (new (DefaultHttpInterceptorChain())(this$0.chainInterceptors_1, 0)).proceed_voxjs5_k$($httpRequest, $completion);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var t = $p;
        if (t instanceof CancellationException()) {
          throw t;
        }
        throwable = t;
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    var httpResponse = tmp;
    var tmp_1;
    if (httpResponse == null) {
      tmp_1 = flowOf(errorResponse(this$0, $request.operation_1, ensureNotNull(throwable)));
    } else {
      var tmp_2;
      var containsArg = httpResponse.statusCode_1;
      if (!(200 <= containsArg ? containsArg <= 299 : false)) {
        tmp_2 = !get_isGraphQLResponse(httpResponse);
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp_1 = errorResponse_0(this$0, $request.operation_1, httpResponse);
      } else {
        if (get_isMultipart(httpResponse)) {
          tmp_1 = multipleResponses(this$0, $request, $customScalarAdapters, httpResponse);
        } else {
          tmp_1 = singleResponse(this$0, $request, $customScalarAdapters, httpResponse);
        }
      }
    }
    var responses = tmp_1;
    // Inline function 'kotlinx.coroutines.flow.map' call
    // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    var tmp$ret$0 = new (HttpNetworkTransport$execute$1$$inlined$map$1())(responses, this$0, $request, httpResponse, millisStart);
    yield* emitAll($this$flow, tmp$ret$0, $completion);
    return Unit_instance;
  }), 1);
}
var HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1Class;
function HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1() {
  if (HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1Class === VOID) {
    class $ {
      constructor($this, $operation, $request, $customScalarAdapters, this$0, $incrementalResultsMerger) {
        this.$this_1 = $this;
        this.$operation_1 = $operation;
        this.$request_1 = $request;
        this.$customScalarAdapters_1 = $customScalarAdapters;
        this.this$0__1 = this$0;
        this.$incrementalResultsMerger_1 = $incrementalResultsMerger;
      }
      *collect_ooju95_k$(collector, $completion) {
        var tmp = HttpNetworkTransport$multipleResponses$o$collect$slambda(collector, this.$operation_1, this.$request_1, this.$customScalarAdapters_1, this.this$0__1, this.$incrementalResultsMerger_1);
        yield* this.$this_1.collect_aksokr_k$(new (sam$kotlinx_coroutines_flow_FlowCollector$0_0())(tmp), $completion);
        return Unit_instance;
      }
      collect_aksokr_k$(collector, $completion) {
        return this.collect_ooju95_k$(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1Class = $;
  }
  return HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1Class;
}
function HttpNetworkTransport$multipleResponses$slambda($operation, this$0) {
  return constructCallableReference(($this$catch, throwable, $completion) => orPromise($completion, function *($completion) {
    yield* $this$catch.emit_t92u1f_k$(Builder().new_com_apollographql_apollo_api_ApolloResponse_Builder_h8chhh_k$($operation, uuid4()).exception_5qwc7n_k$(wrapIfNeeded(this$0, throwable)).build_1k0s4u_k$(), $completion);
    return Unit_instance;
  }), 2);
}
var HttpNetworkTransportClass;
function HttpNetworkTransport() {
  if (HttpNetworkTransportClass === VOID) {
    class $ {
      constructor(httpRequestComposer, engine, interceptors, exposeErrorBody, incrementalDeliveryProtocol) {
        this.httpRequestComposer_1 = httpRequestComposer;
        this.engine_1 = engine;
        this.interceptors_1 = interceptors;
        this.exposeErrorBody_1 = exposeErrorBody;
        this.incrementalDeliveryProtocol_1 = incrementalDeliveryProtocol;
        this.engineInterceptor_1 = new (EngineInterceptor())(this);
        this.incrementalDeliveryProtocolImpl_1 = get_impl(this.incrementalDeliveryProtocol_1);
        this.chainInterceptors_1 = plus(this.interceptors_1, this.engineInterceptor_1);
      }
      execute_ngxta1_k$(request) {
        var customScalarAdapters = ensureNotNull(request.executionContext_1.get_ourcpn_k$(Key_getInstance()));
        var tmp;
        // Inline function 'kotlin.collections.orEmpty' call
        var tmp0_elvis_lhs = request.httpHeaders_1;
        var tmp0 = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
        var tmp$ret$1;
        $l$block_0: {
          // Inline function 'kotlin.collections.none' call
          var tmp_0;
          if (isInterface(tmp0, Collection())) {
            tmp_0 = tmp0.isEmpty_y1axqb_k$();
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp$ret$1 = true;
            break $l$block_0;
          }
          var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            if (equals_0(element.name_1, 'accept', true)) {
              tmp$ret$1 = false;
              break $l$block_0;
            }
          }
          tmp$ret$1 = true;
        }
        if (tmp$ret$1) {
          var tmp_1;
          var tmp_2 = request.operation_1;
          if (isInterface(tmp_2, Subscription())) {
            tmp_1 = 'multipart/mixed;subscriptionSpec=1.0, application/graphql-response+json, application/json';
          } else {
            tmp_1 = this.incrementalDeliveryProtocolImpl_1.get_acceptHeader_vmdvr2_k$();
          }
          var accept = tmp_1;
          tmp = request.newBuilder_dnl2aj_k$().addHttpHeader_irkgza_k$('accept', accept).build_1k0s4u_k$();
        } else {
          tmp = request;
        }
        var request_0 = tmp;
        var httpRequest = this.httpRequestComposer_1.compose_vpsqtm_k$(request_0);
        return this.execute_semco5_k$(request_0, httpRequest, customScalarAdapters);
      }
      execute_semco5_k$(request, httpRequest, customScalarAdapters) {
        return flow(HttpNetworkTransport$execute$slambda(this, httpRequest, request, customScalarAdapters));
      }
      dispose_3nnxhr_k$() {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = this.interceptors_1.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          element.dispose_3nnxhr_k$();
        }
        this.engine_1.close_yn9xrc_k$();
      }
    }
    initMetadataForClass($, 'HttpNetworkTransport');
    HttpNetworkTransportClass = $;
  }
  return HttpNetworkTransportClass;
}
//region block: exports
export {
  Builder_0 as Builder3d75eph7uovs3,
};
//endregion

//# sourceMappingURL=HttpNetworkTransport.mjs.map
